import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function MyAccount() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const loggedIn = sessionStorage.getItem("isLoggedIn");
    if (loggedIn !== "true") {
      navigate("/login-now");
      return;
    }

    const storedUser = JSON.parse(sessionStorage.getItem("userData")) || {};
    const orderHistory =
      JSON.parse(sessionStorage.getItem("orderHistory")) || [];

    setUser(storedUser);
    setOrders(orderHistory.slice().reverse());
  }, [navigate]);

  const logout = () => {
    sessionStorage.removeItem("isLoggedIn");
    navigate("/login-now");
  };

  return (
    <div className="account-wrapper">
      <div className="container">
        {/* ================================
             NEW MODERN PROFILE HEADER
        =================================== */}
        <div className="acct-modern-header">
          <div className="left">
            <div className="big-avatar">{user?.name?.charAt(0) || "U"}</div>

            <div>
              <h2 className="username">{user?.name || "User"}</h2>
              <p className="user-email">{user?.email}</p>
            </div>
          </div>

          <button className="logout-chip" onClick={logout}>
            Logout ⟶
          </button>
        </div>

        {/* ================================
             QUICK ACTIONS
        =================================== */}
        <div className="quick-actions">
          <Link className="qa-item" to="/cart">
            🛒 <span>My Cart</span>
          </Link>

          <Link className="qa-item" to="/track-order">
            🚚 <span>Track Order</span>
          </Link>

          <Link className="qa-item" to="/shop">
            🛍️ <span>Shop Products</span>
          </Link>
        </div>

        {/* ================================
             ORDER HISTORY
        =================================== */}
        <div className="section">
          <h3 className="section-title">Order History</h3>

          {orders.length === 0 ? (
            <p className="empty">No orders placed yet.</p>
          ) : (
            <div className="order-list">
              {orders.map((order) => (
                <div key={order.id} className="order-row">
                  <div>
                    <strong>{order.orderNumber}</strong>
                    <p className="date">
                      {new Date(order.id).toLocaleDateString()}
                    </p>
                  </div>

                  <div className="order-price">
                    ${order.total.toFixed(2)}
                    <small>
                      {order.method === "cod"
                        ? "Cash on Delivery"
                        : "Online Payment"}
                    </small>
                  </div>

                  <Link className="view-btn" to="/track-order">
                    View →
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ================================
             SAVED ADDRESS
        =================================== */}
        <div className="section">
          <h3 className="section-title">Saved Address</h3>

          {!user?.address ? (
            <p className="empty">No saved address found.</p>
          ) : (
            <div className="address-card">
              <p>
                <strong>{user.name}</strong>
              </p>
              <p>{user.address}</p>
              <p>
                {user.city}, {user.postal}
              </p>
              <p>📞 {user.phone}</p>
            </div>
          )}
        </div>
      </div>

      {/* ================================
             INLINE STYLING
      =================================== */}
      <style>{`
        .account-wrapper {
          padding: 55px 0;
          background: #f5f7fa;
        }

        /* Modern Profile Header */
        .acct-modern-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 20px;
          border-bottom: 1px solid rgba(0,0,0,0.08);
          margin-bottom: 35px;
        }

        .acct-modern-header .left {
          display: flex;
          align-items: center;
          gap: 18px;
        }

        .big-avatar {
          width: 72px;
          height: 72px;
          background: #0b61d6;
          color: white;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          font-weight: 700;
          box-shadow: 0 6px 15px rgba(0,0,0,0.1);
        }

        .username {
          margin: 0;
          font-size: 26px;
          font-weight: 700;
          color: #111;
        }

        .user-email {
          margin-top: 3px;
          color: #676767;
          font-size: 15px;
        }

        .logout-chip {
          background: #f2f3f6;
          border: none;
          padding: 10px 20px;
          border-radius: 40px;
          cursor: pointer;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          transition: 0.25s;
        }

        .logout-chip:hover {
          background: #e3e5ea;
          transform: translateX(4px);
        }

        /* Quick Actions */
        .quick-actions {
          display: flex;
          gap: 15px;
          margin-bottom: 25px;
          flex-wrap: wrap;
        }

        .qa-item {
          background: white;
          padding: 16px 20px;
          border-radius: 14px;
          font-weight: 600;
          font-size: 17px;
          box-shadow: 0 4px 14px rgba(0,0,0,0.06);
          flex: 1;
          min-width: 160px;
          text-align: center;
          text-decoration: none;
          color: #0b61d6;
          transition: 0.2s;
        }

        .qa-item:hover {
          background: #eef4ff;
          transform: translateY(-3px);
        }

        /* Sections */
        .section {
          margin-bottom: 35px;
        }

        .section-title {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 12px;
        }

        .empty {
          color: #777;
        }

        /* Order List */
        .order-list {
          border-top: 1px solid #ddd;
        }

        .order-row {
          display: flex;
          justify-content: space-between;
          padding: 14px 0;
          border-bottom: 1px dashed #ddd;
          align-items: center;
        }

        .date {
          font-size: 13px;
          color: #777;
          margin-top: 3px;
        }

        .order-price {
          font-weight: 700;
          text-align: right;
        }

        .order-price small {
          display: block;
          color: #666;
          font-size: 12px;
        }

        .view-btn {
          color: #0b61d6;
          text-decoration: none;
          font-weight: 600;
        }

        /* Address Block */
        .address-card {
          background: #eef4ff;
          padding: 18px;
          border-radius: 12px;
        }
      `}</style>
    </div>
  );
}

export default MyAccount;
